import { render, staticRenderFns } from "./social-before-selector-dialog.vue?vue&type=template&id=15d890fa&"
import script from "./social-before-selector-dialog.vue?vue&type=script&lang=js&"
export * from "./social-before-selector-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports